module.exports = __webpack_public_path__ + "assets/img/32_640_big.7c3dc9cd.jpg";